import { useEmbeddedContext, useRoleAuth } from '@src/hooks';
import { useAppStateDispatch } from '@src/providers/AppStateProvider';
import {
  ACTION,
  BLOTTER_TABLE_FILTERS_CONTAINER_ID,
  Box,
  Button,
  ButtonVariants,
  FormControlSizes,
  HStack,
  IconName,
  MixpanelEvent,
  useMixpanel,
  usePortal,
} from '@talos/kyoko';
import { prime } from '../../../components/OMS/ManualTradeView/ManualTradeSlice';
import { openView } from '../../../components/OMS/OMSSlice';
import { OMSView } from '../../../components/OMS/OMSView';
import { TRADES_MULTILEG_VIEW_CONTAINER_ID } from './tokens';

export function TradesFilterRow() {
  const { isAuthorized } = useRoleAuth();
  const dispatch = useAppStateDispatch();
  const mixpanel = useMixpanel();
  const canSubmitOrder = isAuthorized(ACTION.SUBMIT_ORDER);
  const { isEmbedded } = useEmbeddedContext();

  const handleManualTrade = () => {
    mixpanel.track(MixpanelEvent.OpenManualTradeForm);
    dispatch(prime());
    dispatch(openView(OMSView.ManualTradeForm));
  };

  const { setPortalRef: filtersContainerRef } = usePortal(BLOTTER_TABLE_FILTERS_CONTAINER_ID);
  const { setPortalRef: multilegViewContainerRef } = usePortal(TRADES_MULTILEG_VIEW_CONTAINER_ID);

  return (
    <HStack gap="spacing4">
      <Box ref={multilegViewContainerRef} />
      {canSubmitOrder && !isEmbedded && (
        <Button
          startIcon={IconName.Plus}
          variant={ButtonVariants.Default}
          size={FormControlSizes.Small}
          onClick={handleManualTrade}
          data-testid="manual-trade-button"
        >
          Manual Trade
        </Button>
      )}
      <Box ref={filtersContainerRef} />
    </HStack>
  );
}
